/** Query keys preserved across dashboard URL sync (API target, not tab state). */
const PASSTHROUGH_KEYS = ["env", "api_url"] as const;

/** Copy `env` / `api_url` from the current location into a new query string. */
export function appendPassthroughUrlParams(params: URLSearchParams): void {
  const current = new URLSearchParams(window.location.search);
  for (const key of PASSTHROUGH_KEYS) {
    const value = current.get(key);
    if (value) params.set(key, value);
  }
}
